import { render, staticRenderFns } from "./DamageTemplate.vue?vue&type=template&id=2a027b29"
import script from "./DamageTemplate.vue?vue&type=script&lang=js"
export * from "./DamageTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports